window.app = window.app || {};

window.app.logosBar = {
  wrapper: document.querySelector('.mt-logos-bar__carousel'),
  el: document.querySelector('.mt-logos-bar__carousel .swiper'),
  items: document.querySelectorAll('.mt-logos-bar__item'),

  init: function() {
    const _this = this;
    if (!_this.el) return;

    const itemsRatio = [..._this.items].map(item => {
      const ratio = parseFloat(item.dataset.ratio);
      return Math.floor(ratio * 100) / 100;
    });
    const itemsSet = new Set(itemsRatio);

    _this.slider = new Swiper(_this.el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: true,
      watchSlidesProgress: true,
      spaceBetween: 24,
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 30,
      speed: (itemsSet.size > 1) ? 4500 : 2500,
      loop: true,
      forceLoop: false,
      freeMode: false,
      autoplay: {
        delay: 10,
        disableOnInteraction: false,
        pauseOnMouseEnter: false	
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          spaceBetween: 50
        }
      }
    });

    _this.slider.on('touchStart', s => {
      s.speed = 100;
    });

    // Fix for mobile
    const fixSlider = () => {
      _this.slider.update();
      _this.slider.autoplay.resume();
    };
    const carouselIntersection = (entries, observer) => entries.forEach(entry => entry.isIntersecting && fixSlider());
    const carouselObserver = new IntersectionObserver(carouselIntersection, { root: null, rootMargin: '0px', threshold: 0.1 });
    carouselObserver.observe(_this.el);
    setTimeout(() => fixSlider(), 3000);
  }
}
window.app.logosBar.init();